function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "prefix__a",
  d: "M0 0H18V18H0z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#prefix__a"
})), React.createElement("path", {
  stroke: "#0082FF",
  strokeWidth: 1.2,
  d: "M3.6 4.6V15c0 .773.627 1.4 1.4 1.4h8c.773 0 1.4-.627 1.4-1.4V4.6H3.6z",
  mask: "url(#prefix__b)"
}), React.createElement("path", {
  stroke: "#0082FF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M1.5 4.5h15M7.5 8.5v4M10.5 8.5v4",
  mask: "url(#prefix__b)"
}), React.createElement("path", {
  stroke: "#0082FF",
  strokeWidth: 1.2,
  d: "M5.5 4v-.5c0-1.105.895-2 2-2h3c1.105 0 2 .895 2 2V4",
  mask: "url(#prefix__b)"
}));

var SvgIcoRemove = function SvgIcoRemove(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoRemove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-remove.f626bdf0.svg";
export { ForwardRef as ReactComponent };